import { useEffect } from "react";

import { bindGlobalHapticFeedback } from "../../utils/hapticFeedback";

export default function GlobalHapticFeedback() {
   useEffect(() => bindGlobalHapticFeedback(), []);
   return null;
}
